import { render, staticRenderFns } from "./BatteryDisplay.vue?vue&type=template&id=4228d492"
import script from "./BatteryDisplay.vue?vue&type=script&lang=ts"
export * from "./BatteryDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports